import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer.jsx';
import { CusFormLabel } from '../validation/Form-Components.jsx';
import loApprovedImg from '../hybridImages/appStatusLOApproved.png';
import loProcessingImg from '../hybridImages/appStatusLOProcessing.png'
import service from '../services/StatusEnquiryApiService.js';
import Loading from '../components/Loading.jsx';
import helper from '../factory/Helper.js';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import config from '../appconfig/config.json';
import CusSavePrint from '../components/CusSavePrint.jsx';
import CusCancelApp from '../components/CusCancelApp.jsx';
import CusGreenBtn from '../components/CusGreenBtn.jsx';
import storage from '../factory/StorageFactory.js';
import LoadingText from '../components/LoadingText.jsx';
import mData from '../hybriddata/mainform.json';
import nldata from '../hybriddata/nonlendingdata.json';
import losData from '../hybriddata/loanstatusdata.json';

const HStatusInfoDetails = (props) => {
    
    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();
    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const [buttonPopup, setButtonPopup] = useState(false);
    const [isCancelling,setIsCancelling] = useState(false);

    useEffect(() => {
        console.log('@HybridApproved useEffect');
 
        window.scrollTo(0, 0);
        getPropsData();
        //clearData();
    }, []);

    const getPropsData = () => {   //parse form preview or resume application 
      
        if (props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response : '';
            // console.log('getPropsData',resData)
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            setIsLoading(false);
        }
        else {
            //redirect to error 
            console.log('error')
        }
    }
    //export and print pdf
    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: response.StatusDtls.ApplicationNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSStatusDetails');
        return url;
    }

    const handleCancelApplication = () => {
        //do cancel api here.
        setIsCancelling(true);
        service.cancel(refNo,uen).then(res => {
            setIsCancelling(false);
            if (res.data.isSucess) {
                //cancel success
                setButtonPopup(false);
                props.history.push(config.route.AppCancelled);
            }
        })
        .catch(err => {
            console.log('err: ', err);
            setIsCancelling(false);
        })
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }
    
    const isProductAIP = () => {
   
        if(response.StatusDtls.ProductType === config.bizFinancing.AIP) {
            return true;
        }

        return false;
    }

 
    const getPurposeString = () => {
        let result = '',temp = [];
        
        if(response.StatusDtls.WCL === 'Y') {
          temp.push(mData.label.chkWCL);
        }
        if(response.StatusDtls.Property === 'Y') {
          temp.push(mData.label.chkProperty);
        }
        if(response.StatusDtls.Trade === 'Y'){
          temp.push(mData.label.chkTrade);
        }
        if(response.StatusDtls.GAS === 'Y') {
          temp.push(mData.label.chkGAS);
        }
        if(response.StatusDtls.ESG === 'Y') {
            temp.push(mData.label.chkESG);
        }
        
        if(temp.length === 1) {
          result = temp[0];
        }
        else {
          result = temp.join(', ');
        }
        
        return result;
    }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }


    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <div className="outerdivsubheader">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <h2 className='completeTitle1 mb-0'>
                             {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP &&
                                <>{'Stay Tuned for your application result.'}</>
                             }
                             {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLA && 
                                <>{'Fantastic! You’re one step away to growing your business.'}</>}
                            </h2>
                        </div>
                    </div>
                </div>
                <FormContainer>
                    <div className='statusImgHeader'>
                     
                        {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP &&
                            <img src={loProcessingImg} alt="loanOfferProcessingImg"></img>
                        }
                        {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLA && 
                            <img src={loApprovedImg} alt="loanOfferApprovedImg"></img>
                        }
                 
                    </div>
                </FormContainer>

                <FormContainer>
                    <div className='row around-xs inputPair elementVisible'>
                        <div style={{ textAlign: 'center', marginLeft:'25px', marginRight:'25px', marginTop:'25px'}}>
                            <h2 className='status-header-txt'>
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLP &&
                                    <>{'Your application is currently being processed. Our dedicated sales personnel will be in touch soon and keep you updated on the result.'}</>
                                }
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.HLA &&
                                    <>{'Your application has been approved. Our dedicated sales personnel will deliver your offer letter soon if there are no further supporting documents required.'}</>
                                }
                            </h2>  
                        </div>
                    </div>
               
                    <div style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>
                    <div style={{ marginLeft: '25px', margingRight: '25px' }}>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                            id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                            id={'uen'} name={response.StatusDtls.UEN} />

               
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                            id={'facility'} name={response.StatusDtls.Facility} />
           

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                            id={'financeType'} name={response.StatusDtls.FinancingType} />

           
                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={isProductAIP()?'Property':getPurposeString()} />
                      
                      {response.StatusDtls.ApplicationProgress !== config.StatusDtls.HLA && 
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Amount'}
                            id={'amt'} name={response.StatusDtls.Amount
                                ? response.StatusDtls.Amount != null
                                    ? 'SGD ' + parseFloat(response.StatusDtls.Amount)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    : ""
                                : ""} />
                      }
                        <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                            id={'combinedApp'} name={getNonLendingString()} />
                            
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                            id={'date'} name={response.StatusDtls.AppDate} />
                    </div>

                    <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                        <hr className="hrgoldline" />
                    </div>
                    <br />

                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />

                    <div style={{ textAlign: "center" }} >
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome} />
                        <br />
                        {/* <CusCancelApp onClick={() => setButtonPopup(true)} pTrigger={buttonPopup} psetTrigger={setButtonPopup}
                            backClick={() => {setButtonPopup(false);}} nextClick={handleCancelApplication} /> */
                            }
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span>{losData.assitance.title}</span>&nbsp;
                                <span className='add-btn-blue'>{losData.assitance.email}</span>
                            </div>
                        </div>
                    </div>
                    <br />
                    <LoadingText show={isCancelling} setShow={setIsCancelling} label={'Cancelling..'} />
                             
                </FormContainer>
                <br />
            </div>
        </PDFExport>
    )
}

export default HStatusInfoDetails;